<c-container class="pt-3">
    <!-- <c-row>
        <c-col class="col-lg-12">
            <c-card>
                <c-card-body>
                    <c-chart [data]="repairerSummaryData" type="line" (chartRef)="handleChartRef($event)"
                        [options]="repairerSummaryOptions" height="450" />
                </c-card-body>
            </c-card>
        </c-col>
    </c-row> -->
    <c-row class="mt-3">
        <!-- <c-col>
            <c-card>
                <c-card-header class="card-header">
                    <h4 class="card-header__heading">Average time at repairer monthly</h4>
                </c-card-header>
                <c-card-body>

                    <table datatable class="table table-striped">
                        <thead>
                          <tr>
                            <th>Reg</th>
                            <th>Model</th>
                            <th>Consecutive Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let vehicle of vehicleConsecutiveDaysData">
                            <td>{{ vehicle.reg }}</td>
                            <td>{{ vehicle.model }}</td>
                            <td>{{ vehicle.consecutiveDays }}</td>
                          </tr>
                        </tbody>
                      </table>
                      


                </c-card-body>
            </c-card>
        </c-col> -->

        <c-col>
            <div class="card">
                <div class="card-header">
                    <h4 class="card-header__heading">Top Unused Vehicle Count by Day</h4>
                    <h6 style="display: flex; align-items: center; margin-top: 0.3rem;" *ngIf="(!queryParamsLength)">Date Range: last 30 days
                    
                        <!-- <select *ngIf="categories.length" style="width: auto; margin-left: 0.5rem;" aria-label="Default select example" cSelect sizing="lg">
                            <option [value]="''">
                                Choose Category
                            </option>
                            <option *ngFor="let category of categories" [value]="category">
                                {{category.display_name}}
                            </option>
                        </select> -->
                    
                    </h6>
                </div>

                <div class="card-body">
                    <c-smart-table #smartTable="cSmartTable" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="20" [columns]="columns"
                    [items]="vehicleConsecutiveDaysData" [tableProps]="{ hover: true, striped: true, responsive: true }"
                    activePage="1" header pagination  [itemsPerPageSelect]="true">
    
                    </c-smart-table>
                </div>
               </div>
        
        </c-col>

    </c-row>

</c-container>